import { useUtils } from "@/app/hooks/useUtils";
import clsx from "clsx";

const BookingDateTime: React.FC<{
  startDateTime: string; // ISO String,
  className?: string;
}> = (props) => {
  const { ISOToRelativeTime } = useUtils();
  return <span className={clsx(props?.className)}>{ISOToRelativeTime(props?.startDateTime)}</span>;
};

export default BookingDateTime;
